enum InputFieldFeedbackStatus {
  ERROR,
  NONE,
  SUCCESS,
}

export default InputFieldFeedbackStatus;
